import { api } from "../api";

export const getAllEvents = function(lockerId, callback) {
  const URL = `/events?filter[lockerId]=${lockerId}&limit=60`;
  const URL2 = `/lockers/${lockerId}/events`;

  api
    .get(URL2)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback([]);
      console.log("Error:. " + error);
    });
};


export const createEvent = function(data, callback) {
  const URL = `/events`;

  api
    .post(URL, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback([]);
      console.log("Error:. " + error);
    });
};
